import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSupabaseAuth } from '../../hooks/useSupabaseAuth';
import { useProfile } from '../../hooks/useProfile';

const ProtectedRoute = () => {
  const { user, loading: authLoading } = useSupabaseAuth();
  const { profile, loading: profileLoading } = useProfile();
  const location = useLocation();

  if (authLoading || (user && profileLoading)) {
    return <div className="h-screen w-screen flex items-center justify-center">Loading...</div>;
  }

  if (!user) {
    const stayLoggedIn = localStorage.getItem('sevenhats_stay_logged_in') !== 'false';
    return <Navigate to={stayLoggedIn ? '/login' : '/'} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
